var _path, _g, _path2, _g2, _path3, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIreland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_48694",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3257 0.385742H0.762695V19.9637H34.3257V0.385742Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_48694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9507 0.385742H0.762695V19.9637H11.9507V0.385742Z",
    fill: "#409A63"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_48694",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3257 0.385742H0.762695V19.9637H34.3257V0.385742Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_48694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1372 0.385742H11.9492V19.9637H23.1372V0.385742Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_48694",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3257 0.385742H0.762695V19.9637H34.3257V0.385742Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_48694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3257 0.385742H23.1377V19.9637H34.3257V0.385742Z",
    fill: "#EE7E46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIreland);
export default __webpack_public_path__ + "static/media/IRELAND.1236de37a1aff41e1e0a4fc0e946f762.svg";
export { ForwardRef as ReactComponent };